// extracted by mini-css-extract-plugin
export var wave = "WavingHand-module--wave--2Q5Ou";
export var waveAnimation = "WavingHand-module--wave-animation--3IJhz";